<template>

</template>
<script>
import Notification from "../helpers/Notification";

export default {
    name:  'FormErrors',
    data() {
        return {
            errors: {}
        };
    },
    methods: {
        setErrors(errors) {
            Notification.methods.warning(this.$t('Please fill required fields'));
            this.errors = errors;
        },
        hasError(field){
            return (field in this.errors);
        },
        getError(field){
            return (field in this.errors) ? this.errors[field][0] : null;
        },
        clearError(event) {
            delete this.errors[event.target.name=='telephone'?'mobile':event.target.name];
        },
        clearAllErrors() {
            this.errors = {};
        }
    },
    computed: {
        hasAnyError() {
            return Object,keys(this.errors).length > 0;
        }
    }
}
</script>
